import React, { useEffect, useState } from 'react';
import DelayRender from './DelayRender';
import './Settings.css';

const themes = [
  { name: 'Original', value: 'default' },
  { name: 'Geo', value: 'colour' },
  { name: 'Cali', value: 'version2' },
  { name: 'Space', value: 'space' },
  { name: 'Night', value: 'night' },
];

const Settings = () => {
  const [selectedTheme, setSelectedTheme] = useState('default');

  useEffect(() => {
    const savedTheme = localStorage.getItem('theme') || 'default';
    setSelectedTheme(savedTheme);
    document.documentElement.setAttribute('data-theme', savedTheme);
  }, []);

  const handleThemeChange = (value) => {
    setSelectedTheme(value);
    document.documentElement.setAttribute('data-theme', value);
    localStorage.setItem('theme', value);
  };

  return (
    <div className="settings-container">
      <h2>Settings</h2>
      <p>Adjust your settings here.</p>
      <div className="theme-switcher">
        <h3>Select Theme:</h3>
        <div className="theme-options">
          {themes.map((theme) => (
            <button
              key={theme.value}
              className={`theme-option ${selectedTheme === theme.value ? 'selected' : ''}`}
              onClick={() => handleThemeChange(theme.value)}
            >
              {theme.name}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default DelayRender(Settings, 300);
